import request from '@/utils/request'
const apiPath = '/cust/customer'
import { downloadBlob } from '@/utils/download'
const customerApi = {
  /**
   * 新增【管辖区域】
   */
  create(data) {
    return request.post(apiPath + '/tee', data)
  },
  /**
   * 修改【管辖区域】
   */
  update(data) {
    return request.put(apiPath + '/tee', data)
  },
  /**
   * 分页查询【管辖区域】
   */
  fetchList(query) {
    return request.get(apiPath + '/tee/list', { params: query })
  },
  listForMini(query) {
    return request.get(apiPath + '/tee/listForMini', { params: query })
  },
  /**
   * 查询【管辖区域】选项列表
   */
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },
  /**
   * 查看【管辖区域】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【管辖区域】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  exportExcel(query) {
    return request.get(`${apiPath}/export`, { responseType: 'blob', params: query })
      .then(res => downloadBlob(res, '商品列表.xlsx'))
  },
  getAreaYe(data) {
    return request.post(apiPath + '/getAreaYe', data)
  },
  getYwCustomer(data) {
    return request.post(apiPath + '/getYwCustomer', data)
  },
  updateCustomerAreaRelation(data) {
    return request.post(apiPath + '/updateCustomerAreaRelation', data)
  },
  updateisareatime(data) {
    return request.post(apiPath + '/updateisareatime', data, { isFormData: 1 })
  },
}
export default customerApi
